import Tbl from "../../input_types/Tbl/Tbl";

export default function Pdts(){


    return <div
        className="container"
    >
        <Tbl
            tblName={"pdts"}
            showIndex= {false}
            hideListTypeSelector={true}
            hideListFldsSelector={false}
            hideTitle={true}
            hideNewBtn={false}
            // useParams
            listFlds={"sn,name"}
        ></Tbl>
    </div>;
}